'use strict';

require('../groups/CompanyGroupService.js');
require('../groups/CompanyGroupUserService.js');
require('../../user/CurrentUserService.js');
require('../publications/CompanyPublicationService.js');
require('../form-app-submit-group/FormAppSubmitGroupService.js');
require('../form-app-submit-group/FormAppSubmitGroupUserService.js');

function CompanyCustomerPortalsNewCtrl(
  $scope,
  translations,
  $state,
  $stateParams,
  growl,
  CompanyGroupService,
  CompanyGroupUserService,
  FormAppSubmitGroupService,
  FormAppSubmitGroupUserService,
  CompanyService,
  CurrentUserService,
  CompanyPublicationService) {
  $scope.customerPortal = {
    name: [""],
    type: 'VISIBLE'
  };
  $scope.isCreateFormApp = $stateParams.isCreateFormApp ? true : false;
  $scope.isCreatePortal = $stateParams.isCreateFormApp ? false : true;
  $scope.createType = 'SINGLE';

  $scope.state = $state;

  $scope.guestViews = [
    {
      "label": translations['customer-portal.template.default'],
      "value": "DEFAULT"
    },
    {
      "label": translations['customer-portal.template.my-page'],
      "value": "MYPAGE"
    }
  ];
  $scope.customerPortal.view = $scope.guestViews[0].value;

  $scope.save = function() {
    $scope.customerPortal.name.map(function(n){
      var customerPortal = angular.copy($scope.customerPortal);
      customerPortal.name = n;
      if($scope.isCreateFormApp){
        FormAppSubmitGroupService.save({companyId: $stateParams.companyId}, customerPortal, function(resp, headers) {
          $scope.customerPortalForm.$setPristine();
          var newId = headers('Location').split('/').pop();
          if($scope.addCurrentUser) {
            CurrentUserService.get().then(function(user) {
              FormAppSubmitGroupUserService.save({companyId: $stateParams.companyId, groupId: newId}, user);
            });
          }
          $state.go('root.company.customerPortals.list', {companyId: $stateParams.companyId});
          growl.addSuccessMessage(translations['form-app.create-success']);
        }, function(resp) {
          if (resp.status === 400 && resp.data.error && resp.data.error.code === 1613) {
            growl.addErrorMessage(translations['form-app.reached-your-limit']);
          } else {
            growl.addErrorMessage(translations['form-app.create-failure']);
          }
        });
      }
      if($scope.isCreatePortal){
        CompanyGroupService.save({companyId: $stateParams.companyId, type: 'VISIBLE'}, customerPortal, function(resp, headers) {
          $scope.customerPortalForm.$setPristine();
          var newId = headers('Location').split('/').pop();
          // Check option to add current user to this customer portal
          if($scope.addCurrentUser) {
            CurrentUserService.get().then(function(user) {
              CompanyGroupUserService.save({companyId: $stateParams.companyId, groupId: newId}, {id: user.id});
            });
          }

          if ($scope.addCurrentDocument && $stateParams.publicationId) {
            CompanyPublicationService.get({companyId: $stateParams.companyId, publicationId: $stateParams.publicationId}, function (publication) {
              publication.groups.push(newId);
              publication.$update({companyId: $stateParams.companyId}, function(){
                if(publication.type !== 'FORM'){
                  $state.go('root.company.publication.share-access', {companyId: $stateParams.companyId, publicationId: $stateParams.publicationId, activeTab: 4}, {reload: true});
                }
              });
            });
          } else {
            $state.go('root.company.customerPortals.list', {companyId: $stateParams.companyId});
          }

          growl.addSuccessMessage(translations['customer-portal.create-success']);
        }, function() {
          growl.addSuccessMessage(translations['customer-portal.create-failure']);
        });
      }
    });
  };
  $scope.customerPortal.tags = [];
  $scope.inputTags = angular.copy($scope.customerPortal.tags);
  $scope.convertTags = function() {
    var newTags = [];
    newTags = $scope.inputTags.map(function(tag) { return tag.text; });
    angular.copy(newTags, $scope.customerPortal.tags);
  };

  $scope.loadTags = function() {
    return CompanyService.queryTags({companyId: $stateParams.companyId}).$promise;
  };

  $scope.setGroupCategory = function(category) {
    if (!category) {
      $scope.customerPortal.category = null;
    } else {
      $scope.customerPortal.category = category;
    }
  };

  $scope.toggleSingle = function() {
    $scope.createType = 'SINGLE';
    $scope.customerPortal.name.splice(1);
  };

  $scope.toggleBulk = function() {
    $scope.createType = 'BULK';
    $scope.bulkAddItem();
  };

  $scope.bulkAddItem = function() {
    if ($scope.customerPortal.name.length < 20) {
      $scope.customerPortal.name.push('');
    }
  };

  $scope.bulkRemoveItem = function(item) {
    if (item > 0) {
      $scope.customerPortal.name.splice(item, 1);
    }

    if ($scope.customerPortal.name.length === 1) {
      $scope.toggleSingle();
    }
  };

}

CompanyCustomerPortalsNewCtrl.resolve = {
  translations: ['$translate', function($translate) {
    return $translate([
      'customer-portal.create-success',
      'customer-portal.create-failure',
      'customer-portal.template.default',
      'customer-portal.template.my-page',
      'form-app.create-success',
      'form-app.create-failure',
      'form-app.reached-your-limit'
    ]);
  }]
};
module.exports = CompanyCustomerPortalsNewCtrl;

angular.module('dokiv')
  .controller('CompanyCustomerPortalsNewCtrl', [
    '$scope',
    'translations',
    '$state',
    '$stateParams',
    'growl',
    'CompanyGroupService',
    'CompanyGroupUserService',
    'FormAppSubmitGroupService',
    'FormAppSubmitGroupUserService',
    'CompanyService',
    'CurrentUserService',
    'CompanyPublicationService',
    CompanyCustomerPortalsNewCtrl]);




//////////////////
// WEBPACK FOOTER
// ./scripts/company/customer-portals/CompanyCustomerPortalsNewCtrl.js
// module id = 331
// module chunks = 0